import './styles/App.css';
import './styles/gallery.css';
import React from 'react'
import { ethers } from 'ethers';
import { useState , useEffect} from 'react';
import connector from './utils.js'
import {Link} from 'react-router-dom';
import Button from '@mui/material/Button';

function PresentGetter(props) {
  const [contract, setContract]=useState('undefined');
  const [signer,setSigner] = useState('');
  const [provider,setProvider] = useState('');
  const [accounts,setAccounts] = useState([]);
  const [presents,setPresents] = useState([]);
  const [filtered,setFiltered] = useState([]);
  useEffect(() => {
    const init = async()=>{
      const lis = await connector(props.address);
      setContract(await lis.contract);
      setProvider(await lis.provider);
      setAccounts(await lis.accounts);
      setSigner(await lis.signer)
    }
    init();
    
  },[]);
  useEffect(()=>{
    const getPresents = async()=>{
      var id = await contract.connect(signer).startId();
      var presents = [];
      for (var i = 1; i<id;i++){
        var pres = await contract.connect(signer).idToPresent(i);
        presents.push(pres); 
      }
      console.log(presents)
      setPresents(presents);
      setFiltered(presents);
    }
    getPresents();
  },[contract])
  
  function display (){
    let stars =[]
    for (let i =0; i <filtered.length ;i++){
      let pr = filtered[i]
      var des = pr.desc;
      var neDe = pr.desc
      let gender
      if(des.length>=30){
        neDe= des.substring(0, 30) + "..."
      }      
      if(pr.gender == 1){
        gender = "♀"
      }
      if(pr.gender == 2){
        gender = "♂"
      }
      if(pr.gender == 3){
        gender = "⚥"
      }
      let label = pr.name + " . " + pr.price
      let lael = pr.age + " , " + gender+"        "+pr.rating/10 +"⭐"
      let pathP = "/"+pr.id; 
      stars.push(
        <Link to={pathP} id='photoLink'> 
          <div>
            <img id = "itemPhoto" src= {pr.photo}></img>
            <div id ="itemInfo">
              <p id ="itemName" className='tee'>{label}</p>
              <pre id ="itemAge" className='tee'>{lael}</pre>
            </div>
          </div>
        </Link>
      )
    }
    return(stars)
  }
  async function handleSubmit(event){
    event.preventDefault()
    const ch = (event.target[0].value).toLowerCase()
    var filtAr = []
    for (var i=0; i<presents.length;i++){
      var pre = presents[i];
      const ch1 = pre.name.toLowerCase()
      if(ch1.includes(ch)){
        console.log(pre)
        const sele = (event.target[1].value)
        if (sele<4){
          if(pre.gender == sele){filtAr.push(pre)}
          }
          if(sele ==4){
            filtAr.push(pre)
          }
      }
      }
    setFiltered(filtAr)
    console.log(filtAr)
  }
  return (
    <div className='App'>
    <link href="https://fonts.googleapis.com/css2?family=Lato:wght@900&display=swap" rel="stylesheet"></link>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
    <nav>
      <div className='linkButton' id ='linkbutton'>
        <Link to ="/" id="homeLink" className='homelink'></Link>
        <Link to ="/" id="logo"></Link>      
        <Link to="/add" id = "addLink">
          <button id = 'addButt'>ADD PRESENT</button>
        </Link>  
        <Link to="/profile" id = "profLink">
          <button id = 'profButt'>PROFILE</button>
        </Link>  
      </div>
    </nav>
    <div id ="filter" class= 'filter'>
      <form onSubmit={handleSubmit}>
        <input type="text" ></input>
        <select id="gender">
          <option className='opt' value="4" selected> 
            <span> ALL </span>
          </option>
          <option className='opt' value="1">
            <span>&#9792; :  Female  </span>
          </option>
          <option className='opt' value="2">
            <span>&#9794; :  Male  </span>
          </option>
          <option className='opt' value="3" > 
            <span>&#9893; : Other  </span>
          </option>
        </select>
        <Button variant='contained' type = 'submit'>Submit</Button>
      </form>
    </div>
    <div id = "gridDesign">
      {display()}
    </div>
    
    </div>
  );
}
export default PresentGetter
